import React from 'react';
import {Grid} from '@mantine/core';
import {useFormikContext} from "formik";
import MantineSelectField from "../../../../FormikUtils/MantineSelectField";
import MantineInputField from "../../../../FormikUtils/MantineInputField";

export default function PolizaForm(props) {
    const {
        formField: {
            infoDePago: {
                numeroCbu, marcaTarjeta, numeroTarjeta,
            },
            formaDePago,
        }
    } = props;
    const {values} = useFormikContext();

    const formasDePago = [
        // {value: '0', label: 'Efectivo'},
        {value: '4', label: 'Débito por CBU'},
        {value: '2', label: 'Tarjeta de crédito'}
    ];

    const idsTarjeta = [
        {value: '1', label: 'Cabal'},
        {value: '5', label: 'Visa'},
        {value: '7', label: 'Favacard'},
        {value: '9', label: 'American Express'},
        {value: '12', label: 'Naranja'},
        {value: '16', label: 'Diners Club'},
        {value: '18', label: 'Naranja Visa'},
        {value: '20', label: 'Cordobesa - Matercard'},
        {value: '23', label: 'TDF - Tierra del Fuego'},
        {value: '45', label: 'Mastercard Nueva'},
        {value: '57', label: 'ELEBAR'},
        {value: '70', label: 'Censosud  Mastercard'},
    ];

    return (
        <React.Fragment>
            <Grid gutter="md" justify="center" align="center">

                <Grid.Col xs={12} sm={6}>
                    <MantineSelectField
                        name={formaDePago.name}
                        label={formaDePago.label}
                        data={formasDePago}
                    />
                </Grid.Col>

                <Grid.Col xs={12} sm={6}/>

                {values.formaDePago === '2' && (
                    <>

                        <Grid.Col xs={12} sm={6}>
                            <MantineSelectField
                                name={`infoDePago.${marcaTarjeta.name}`}
                                label={marcaTarjeta.label}
                                data={idsTarjeta}
                            />
                        </Grid.Col>
                        <Grid.Col xs={12} sm={6}>
                            <MantineInputField
                                name={`infoDePago.${numeroTarjeta.name}`}
                                label={numeroTarjeta.label}
                            />
                        </Grid.Col>
                    </>
                )}
                {values.formaDePago === '4' && (
                    <>
                        <Grid.Col xs={12} sm={6}>
                            <MantineInputField
                                name={`infoDePago.${numeroCbu.name}`}
                                label={numeroCbu.label}
                            />
                        </Grid.Col>

                        <Grid.Col xs={12} sm={6}/>
                    </>
                )}
            </Grid>
        </React.Fragment>
    );
}
